import React, { useEffect, useState } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { App, Col, Image, Upload, UploadProps } from 'antd';

import { blobToBase64 } from '../../../../../utils/common/blobToBase64';
import { dummyRequest } from '../../../../../utils/common/dummyRequest';

const MAX_IMAGE_SIZE = 10000;

export const BroadcastImageUploader = ({
    formik,
    values,
    imageUrl: dataImageUrl,
}) => {
    const [imageUrl, setImageUrl] = useState<string>(values?.image);
    const { notification } = App.useApp();

    useEffect(() => {
        if (values?.content?.media_url) {
            setImageUrl(values?.content?.media_url);
        }
        if (values) {
            setImageUrl(values.image);
        }
        if (dataImageUrl) {
            setImageUrl(dataImageUrl);
        }
    }, [values?.image, values?.content?.media_url, dataImageUrl]);

    const handleChange: UploadProps['onChange'] = info => {
        if (info.file.status === 'uploading') {
            return;
        }
        if (info.file.status === 'done') {
            const file = info.file.originFileObj as File;
            const img = new window.Image();
            img.src = URL.createObjectURL(file);
            img.onload = () => {
                if (img.width + img.height >= MAX_IMAGE_SIZE) {
                    notification.error({
                        message: `Сумма высоты и ширины картинки не должна превышать ${MAX_IMAGE_SIZE}пикселей`,
                    });

                    return setImageUrl('');
                } else blobToBase64(file).then(url => setImageUrl(url));
            };
        }
    };

    return (
        <Upload
            name='image'
            maxCount={1}
            customRequest={file => {
                void dummyRequest(file.onSuccess);
            }}
            beforeUpload={file => {
                formik.setFieldValue(`image`, file);
            }}
            onChange={handleChange}
            listType='picture-card'
            showUploadList={false}
        >
            {imageUrl ? (
                <Col span={24}>
                    <Image
                        style={{ maxWidth: '100px', maxHeight: '100px' }}
                        preview={false}
                        src={imageUrl}
                    />
                </Col>
            ) : (
                <div>
                    <PlusOutlined />
                    <div style={{ marginTop: 8 }}>Загрузить</div>
                </div>
            )}
        </Upload>
    );
};
